import React from "react"

export default () => {
  const [checkoutLink, setCheckoutLink] = React.useState<string | null>(null)
  const [queue, setQueue] = React.useState<Array<(checkoutLink) => void>>([])

  const updateCheckoutLink = (checkoutLink) => {
    setCheckoutLink(checkoutLink)
  }

  const waitForCheckoutLink = React.useCallback(
    (queuedCallback) => {
      if (checkoutLink) {
        queuedCallback(checkoutLink)
      } else {
        setQueue([...queue, queuedCallback])
      }
    },
    [checkoutLink]
  )

  React.useEffect(() => {
    if (checkoutLink && queue.length) {
      queue.forEach((callback) => {
        callback(checkoutLink)
      })

      setQueue([])
    }
  }, [checkoutLink, queue])

  return {
    updateCheckoutLink,
    waitForCheckoutLink,
  }
}
